<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">CREA UTENTE</div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_name" class="form-label label-fw">
                        Nome *
                    </label>
                    <input  formControlName="name" 
                            name="name" 
                            type="text" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.name.errors}"
                            class="form-control form-fw " 
                            id="field_name" 
                            placeholder="Nome">
                        <div class="invalid-feedback" *ngIf="form.touched">
                            <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
                                Nome è obbligatorio
                            </span>
                        </div>
                </div>
            </div> 


            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_surname" class="form-label label-fw">
                        Cognome *
                    </label>
                    <input  formControlName="surname" 
                            name="surname" 
                            type="text" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.surname.errors}"
                            class="form-control form-fw " 
                            id="field_surname" 
                            placeholder="surname">
                        <div class="invalid-feedback" *ngIf="form.touched">
                            <span *ngIf="formControls.surname.errors && formControls.surname.errors?.required">
                                Cognome è obbligatorio
                            </span>
                        </div>
                </div>
            </div> 


            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_surname" class="form-label label-fw">
                        Email *
                    </label>
                    <input  formControlName="email" 
                            name="email" 
                            type="text" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.email.errors}"
                            class="form-control form-fw " 
                            id="field_email" 
                            placeholder="email">
                        <div class="invalid-feedback" *ngIf="form.touched">
                            <span *ngIf="formControls.email.errors && formControls.email.errors?.required">
                                Email è obbligatorio
                            </span>
                        </div>
                </div>
            </div> 
            

            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_role" class="form-label label-fw">
                        Ruolo *
                    </label>
                    <select formControlName="role" 
                            name="role" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.role.errors}"
                            class="form-select select-wh" 
                            id="field_role">
                        <option value="">Nessuna</option>
                        <option value="{{role.id}}"  *ngFor="let role of roles">
                            {{role.name}}
                        </option>                    
                    </select>
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.role.errors && formControls.role.errors?.required">
                            Ruolo è obbligatorio
                        </span>
                    </div>
                </div>
            </div> 

           
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <div class="form-check form-switch d-flex px-3">
                        <div class="justify-content-start w-100">
                            <label class="form-check-label toggle-text label-fw"
                                for="flexSwitchCheckChecked">Abilita</label>
                        </div>
                        <div class="justify-content-end">
                            <label class="switch">
                                <input  formControlName="enabled" 
                                        name="enabled" 
                                        type="checkbox">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div> 

        </div>
    </form>

    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3" 
                [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false" 
                (click)="clickButtonSave()">Salva</button>
            <button type="button" class="btn btn-outline-fw text" (click)="clickButtonCancel()">Annulla</button>
        </div>
    </div>
</div>